import * as React from 'react';
import { useIntl } from 'react-intl';
import PermissionsService from '../../../Services/PermissionsService';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../CmdTableService';

interface DetailActionProps {
  id: number;
  tableName: string;
  onClickCallback: (id: number, customerId?: number) => void;
  customerId?: number;
}

function DetailAction(props: DetailActionProps) {
  const { formatMessage: f } = useIntl();
  const { trackEvent } = useAnalytics();

  const isDisabled = !PermissionsService.hasAccess(
    props.tableName,
    ['read', 'update'],
    props.customerId || null
  );

  const handleOnClick = () => {
    props.onClickCallback(props.id, props.customerId);
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Detail action']);
  };

  return (
    <button
      type="button"
      title={f({ id: 'table.detailBtn' })}
      data-cy="table-detail-action"
      className="cmd-table-text-gray w-full"
      data-type="detail"
      data-id={props.id}
      // style={{ padding: '10px 25px', margin: '-10px -25px', textAlign: 'center' }}
      style={isDisabled ? { color: '#ccc' } : undefined}
      onClick={handleOnClick}
      disabled={isDisabled}
    >
      <i className="cmd-icon cmd-icon-detail fs-4" />
      <span className="sr-only">{f({ id: 'table.detailBtn' })}</span>
    </button>
  );
}

export default DetailAction;
